"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TURN_PAGE_MODE = exports.List = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _Message = require("../Message");
var _reactSvg = require("react-svg");
var _arrow_left = _interopRequireDefault(require("../../assets/images/arrow_left.svg"));
var _arrow_right = _interopRequireDefault(require("../../assets/images/arrow_right.svg"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var PREFIX = (0, _getPrefixCls.getPrefixCls)('list');
var TURN_PAGE_MODE;
exports.TURN_PAGE_MODE = TURN_PAGE_MODE;
(function (TURN_PAGE_MODE) {
  TURN_PAGE_MODE["click"] = "click";
  TURN_PAGE_MODE["touchMove"] = "touchMove";
})(TURN_PAGE_MODE || (exports.TURN_PAGE_MODE = TURN_PAGE_MODE = {}));
var ButtonType;
(function (ButtonType) {
  ButtonType[ButtonType["pre"] = 0] = "pre";
  ButtonType[ButtonType["next"] = 1] = "next";
})(ButtonType || (ButtonType = {}));
var SWIPE_CONTROL;
(function (SWIPE_CONTROL) {
  SWIPE_CONTROL[SWIPE_CONTROL["default"] = 0] = "default";
  SWIPE_CONTROL[SWIPE_CONTROL["horizontal"] = 1] = "horizontal";
  SWIPE_CONTROL[SWIPE_CONTROL["vertical"] = 2] = "vertical";
})(SWIPE_CONTROL || (SWIPE_CONTROL = {}));
var START_PAGE_NUMBER = 0;
var ValidSwipe = 5;
var ANIMATION_TRANSITION = '0.3s';
var MAX_TURN_PAGES = 1;
var INERTIAL_SLIDE_DURATION_THRESHOLD = 300;
var INERTIAL_SLIDE_DISTANCE_THRESHOLD = 15;
var INERTIAL_SLIDE_ACCELERATION = 0.003;
var getTranslateXFromMatrix = function getTranslateXFromMatrix(matrix) {
  var _matrix$match, _matrixArr$;
  var matrixArr = (_matrix$match = matrix.match(/\((.+?)\)/g)) === null || _matrix$match === void 0 ? void 0 : _matrix$match[0].split(',');
  return Number(matrixArr === null || matrixArr === void 0 ? void 0 : (_matrixArr$ = matrixArr[4]) === null || _matrixArr$ === void 0 ? void 0 : _matrixArr$.trim());
};
var DotsList = function DotsList(props) {
  var value = props.value,
    totalPage = props.totalPage;
  var result = [];
  for (var i = 0; i < totalPage; i++) {
    result.push( /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)('dot', {
        selected: value === i
      }),
      key: i
    }));
  }
  return result;
};
function chunkArray(arr, size) {
  var result = [];
  while (arr.length) {
    result.push(arr.splice(0, Math.min(size, arr.length)));
  }
  return result;
}
var getDistance = function getDistance(distance, maxDistance, hasMovedDistance) {
  return distance > maxDistance - hasMovedDistance ? maxDistance - hasMovedDistance : distance < -maxDistance - hasMovedDistance ? -maxDistance - hasMovedDistance : distance;
};
var List = function List(props) {
  var _props$pageSize = props.pageSize,
    pageSize = _props$pageSize === void 0 ? Infinity : _props$pageSize,
    _props$turnPageMode = props.turnPageMode,
    turnPageMode = _props$turnPageMode === void 0 ? 'click' : _props$turnPageMode,
    title = props.title,
    children = props.children,
    className = props.className;
  var singlePage = (children === null || children === void 0 ? void 0 : children.length) <= pageSize;
  var ele = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    currentPage = _useState2[0],
    setCurrentPage = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    startPointX = _useState4[0],
    setStartPointX = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    startTransformX = _useState6[0],
    setStartTransformX = _useState6[1];
  var _useState7 = (0, _react.useState)(SWIPE_CONTROL.default),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    swipeControl = _useState8[0],
    setSwipeControl = _useState8[1];
  var _useState9 = (0, _react.useState)(0),
    _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
    transformXForInertialSliding = _useState10[0],
    setTransformXForInertialSliding = _useState10[1];
  var _useState11 = (0, _react.useState)(0),
    _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
    startTimeForInertialSliding = _useState12[0],
    setStartTimeForInertialSliding = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
    isMoving = _useState14[0],
    setIsMoving = _useState14[1];
  var _useState15 = (0, _react.useState)(0),
    _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
    hasMovedDistance = _useState16[0],
    setHasMovedDistance = _useState16[1];
  var listItems = chunkArray([].slice.call(children), pageSize);
  var totalPage = listItems.length;
  var showPageControl = !singlePage && turnPageMode === TURN_PAGE_MODE.click;
  if (!singlePage && turnPageMode === TURN_PAGE_MODE.touchMove) {
    listItems.push(listItems[0], listItems[1]);
  }
  var getInertialSlid = function getInertialSlid(current) {
    var now = new Date().getTime();
    var distance = current - transformXForInertialSliding;
    var duration = now - startTimeForInertialSliding;
    if (duration < INERTIAL_SLIDE_DURATION_THRESHOLD && Math.abs(distance) > INERTIAL_SLIDE_DISTANCE_THRESHOLD) {
      var speed = 2 * Math.abs(distance) / duration;
      return speed / INERTIAL_SLIDE_ACCELERATION * (distance < 0 ? -1 : 1);
    }
    return 0;
  };
  var touchStart = function touchStart(ev) {
    var _element$parentElemen;
    var element = ele.current;
    if (!element || !(!singlePage && turnPageMode === TURN_PAGE_MODE.touchMove)) {
      return;
    }
    var current = currentPage;
    var length = listItems.length;
    var width = ((_element$parentElemen = element.parentElement) === null || _element$parentElemen === void 0 ? void 0 : _element$parentElemen.clientWidth) || 0;
    var style = window.getComputedStyle(element);
    var matrix = style.getPropertyValue('transform');
    var offsetX = getTranslateXFromMatrix(matrix) || 0;
    if (current === START_PAGE_NUMBER) {
      current = length - 2;
    } else if (current === length - 1) {
      current = 1;
    }
    var translateX = isMoving ? offsetX : -current * width;
    element.style.transition = 'none';
    element.style.transform = "translateX(".concat(translateX, "px)");
    setCurrentPage(current);
    setStartPointX(ev.touches[ev.touches.length - 1].pageX);
    setStartTransformX(translateX);
    setHasMovedDistance(ev.touches.length > 1 ? (translateX - startTransformX) % width + hasMovedDistance : 0);
    setTransformXForInertialSliding(translateX);
    setStartTimeForInertialSliding(new Date().getTime());
    setIsMoving(true);
  };
  var touchMove = function touchMove(ev) {
    var _element$parentElemen2;
    var element = ele.current;
    if (!element || !(!singlePage && turnPageMode === TURN_PAGE_MODE.touchMove)) {
      return;
    }
    var width = ((_element$parentElemen2 = element.parentElement) === null || _element$parentElemen2 === void 0 ? void 0 : _element$parentElemen2.clientWidth) || 0;
    var maxDistance = MAX_TURN_PAGES * width;
    var now = new Date().getTime();
    var realDistanceX = ev.touches[ev.touches.length - 1].pageX - startPointX;
    var distanceX = getDistance(realDistanceX, maxDistance, hasMovedDistance);
    var translateX = startTransformX + distanceX;
    if (Math.abs(distanceX) <= ValidSwipe && swipeControl !== SWIPE_CONTROL.horizontal || swipeControl === SWIPE_CONTROL.vertical) {
      setSwipeControl(SWIPE_CONTROL.vertical);
      return;
    }
    if (now - startTimeForInertialSliding > INERTIAL_SLIDE_DURATION_THRESHOLD) {
      setTransformXForInertialSliding(translateX);
      setStartTimeForInertialSliding(now);
    }
    setSwipeControl(SWIPE_CONTROL.horizontal);
    element.style.transition = 'none';
    element.style.transform = "translateX(".concat(translateX, "px)");
    ev.preventDefault();
  };
  var touchEnd = function touchEnd(ev) {
    var element = ele.current;
    if (!element || !(!singlePage && turnPageMode === TURN_PAGE_MODE.touchMove) || ev.touches.length > 0) {
      return;
    }
    var _ref = element.parentElement,
      clientWidth = _ref.clientWidth;
    var maxDistance = MAX_TURN_PAGES * clientWidth;
    var matrix = window.getComputedStyle(element).getPropertyValue('transform');
    var translateX = getTranslateXFromMatrix(matrix);
    var slideDistance = getInertialSlid(translateX);
    var distanceX = getDistance(translateX - startTransformX + slideDistance, maxDistance, hasMovedDistance);
    var newTranslateX = startTransformX + distanceX;
    var current = Math.round(-newTranslateX / clientWidth);
    var height = window.getComputedStyle(element.children[current]).getPropertyValue('height');
    element.style.height = height;
    element.style.transition = ANIMATION_TRANSITION;
    element.style.transform = "translateX(".concat(-current * clientWidth, "px)");
    setCurrentPage(current);
    setSwipeControl(SWIPE_CONTROL.default);
    setStartTransformX(0);
    setHasMovedDistance(0);
    setIsMoving(false);
  };
  var clickHeadButtons = function clickHeadButtons(type) {
    var element = ele.current;
    if (!element) {
      return;
    }
    var _ref2 = element.parentElement || {},
      _ref2$clientWidth = _ref2.clientWidth,
      clientWidth = _ref2$clientWidth === void 0 ? 0 : _ref2$clientWidth;
    var nextPage = currentPage;
    if (type === ButtonType.pre) {
      if (currentPage === START_PAGE_NUMBER) {
        return;
      }
      nextPage -= 1;
    } else {
      if (currentPage === totalPage - 1) {
        return;
      }
      nextPage += 1;
    }
    var height = window.getComputedStyle(element.children[nextPage]).getPropertyValue('height');
    element.style.height = height;
    element.style.transition = 'none';
    element.style.transform = "translateX(".concat(-nextPage * clientWidth, "px)");
    setCurrentPage(nextPage);
  };
  (0, _react.useEffect)(function () {
    var _current$children;
    var current = ele.current;
    if ((current === null || current === void 0 ? void 0 : (_current$children = current.children) === null || _current$children === void 0 ? void 0 : _current$children[0]) instanceof Element) {
      var _current$children2;
      var height = window.getComputedStyle(current === null || current === void 0 ? void 0 : (_current$children2 = current.children) === null || _current$children2 === void 0 ? void 0 : _current$children2[0]).getPropertyValue('height');
      current.style.height = height;
    }
    return;
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(PREFIX, className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-title")
  }, /*#__PURE__*/_react.default.createElement(_Message.Message, {
    className: "".concat(PREFIX, "-title-content"),
    content: title || ''
  }), showPageControl && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-title-control")
  }, /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
    src: _arrow_left.default,
    className: (0, _clsx.default)("".concat(PREFIX, "-title-control__left"), {
      disabled: currentPage === START_PAGE_NUMBER
    }),
    onClick: function onClick() {
      return clickHeadButtons(ButtonType.pre);
    }
  }), /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
    src: _arrow_right.default,
    className: (0, _clsx.default)("".concat(PREFIX, "-title-control__right"), {
      disabled: currentPage === totalPage - 1
    }),
    onClick: function onClick() {
      return clickHeadButtons(ButtonType.next);
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-container")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-wrap"),
    ref: ele,
    style: {
      width: "".concat(listItems.length * 100, "%")
    },
    onTouchStart: touchStart,
    onTouchMove: touchMove,
    onTouchEnd: touchEnd
  }, listItems.map(function (listPage, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(PREFIX, "-page"),
      style: {
        width: "".concat(Math.ceil(1 / listItems.length * 100), "%")
      },
      key: index
    }, listPage);
  }))), !singlePage && turnPageMode === TURN_PAGE_MODE.touchMove && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-dots-container")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dots-wrap"
  }, DotsList({
    value: currentPage % totalPage,
    totalPage: totalPage
  }))));
};
exports.List = List;